import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import DynamicBreadcrumbs from "../../Uitiles/DynamicBreadcrumbs";
import { registerapi, getuserdata } from "../../services/apiService";
import { oneKlicks } from "../../SDK/oneclick";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import 'leaflet/dist/leaflet.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LeafletMap from "../../layouts/Frontend/Register/LeafletMap";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useAuth } from '../../context/AuthContext';
import { Link } from "react-router-dom";

const generateRandomString = (length) => {
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
};

const AddAmbulance = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [location, setLocation] = useState({ lat: 17.4109976, lng: 78.5567104 });
    const [address, setAddress] = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth < 700);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        username: "",
        email: "",
        display_name: "",
        termsconditions: false,
        phoneNumber: "",
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
    };

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 700);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrors({});

        const { first_name, last_name, username, email, display_name, termsconditions, phoneNumber } = formData;
        const newErrors = {};

        if (!first_name.trim()) newErrors.first_name = "First name is required.";
        if (!last_name.trim()) newErrors.last_name = "Last name is required.";
        if (!email) newErrors.email = "Email is required.";
        if (!password) newErrors.password = "Password is required.";
        if (password !== confirmPassword) newErrors.conform_password = "Passwords do not match.";
        if (!phoneNumber) newErrors.phoneNumber = "Phone number is required.";
        if (!display_name) newErrors.display_name = "Ambulance service name is required.";
        if (!termsconditions) newErrors.termsconditions = "You must accept the terms.";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            Object.values(newErrors).forEach(err => toast.error(err));
            setLoading(false);
            return;
        }

        try {
            const add_by = await getuserdata('id');
            const ambulanceData = {
                username,
                email,
                first_name,
                last_name,
                display_name,
                address,
                password, // Note: Consider if hashing is needed if not using registerapi
                pass: password, // Some parts of the system use 'pass'
                user_type: "ambulance",
                lat: location.lat,
                lng: location.lng,
                phone: phoneNumber,
                add_by,
                status: '1',
                call_status: '',
                call_remarks: '',
                slug: display_name.toLowerCase().replace(/\s+/g, '-'),
                profile_photo_url: '',
                created_at: new Date().toISOString().slice(0, 19).replace('T', ' '),
                updated_at: new Date().toISOString().slice(0, 19).replace('T', ' ')
            };

            const response = await oneKlicks.create('', 'ambulance', ambulanceData);

            if (response.success) {
                toast.success("Ambulance added successfully!");
                navigate("/superadmin/ambulances");
            } else {
                toast.error(response.message || "Failed to add ambulance");
            }
        } catch (error) {
            console.error("Error adding ambulance:", error);
            toast.error("An unexpected error occurred.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8">
                        <div className="dc-dashboardbox">
                            <div className="dc-dashboardboxtitle">
                                <h2>Add New Ambulance Service</h2>
                            </div>
                            <div className="dc-dashboardboxcontent dc-addservices">
                                <form className="dc-formtheme dc-formregister" onSubmit={handleSubmit}>
                                    <fieldset>
                                        <div className="form-group form-group-half">
                                            <input type="text" name="first_name" className="form-control" value={formData.first_name} placeholder="First Name" onChange={handleChange} />
                                        </div>
                                        <div className="form-group form-group-half">
                                            <input type="text" name="last_name" className="form-control" value={formData.last_name} placeholder="Last Name" onChange={handleChange} />
                                        </div>
                                        <div className="form-group form-group-half">
                                            <input type="text" name="display_name" className="form-control" value={formData.display_name} placeholder="Ambulance Service Name" onChange={handleChange} />
                                        </div>
                                        <div className="form-group form-group-half">
                                            <PhoneInput
                                                international
                                                defaultCountry="IN"
                                                value={formData.phoneNumber}
                                                onChange={val => setFormData({ ...formData, phoneNumber: val })}
                                                placeholder="Enter phone number"
                                                className="form-control"
                                            />
                                        </div>
                                        <div className="form-group form-group-half">
                                            <input type="text" name="username" className="form-control" value={formData.username} placeholder="Username" onChange={handleChange} />
                                        </div>
                                        <div className="form-group form-group-half">
                                            <input type="email" name="email" className="form-control" value={formData.email} placeholder="Email" onChange={handleChange} />
                                        </div>
                                        <div className="form-group form-group-half position-relative">
                                            <input type={passwordVisible ? "text" : "password"} name="password" title="Password" className="form-control" value={password} placeholder="Password" onChange={e => setPassword(e.target.value)} />
                                            <span onClick={() => setPasswordVisible(!passwordVisible)} style={{ position: 'absolute', right: '15px', top: '20px', cursor: 'pointer' }}>
                                                {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                                            </span>
                                        </div>
                                        <div className="form-group form-group-half position-relative">
                                            <input type={confirmPasswordVisible ? "text" : "password"} name="confirm_password" title="Confirm Password" className="form-control" value={confirmPassword} placeholder="Confirm Password" onChange={e => setConfirmPassword(e.target.value)} />
                                            <span onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)} style={{ position: 'absolute', right: '15px', top: '20px', cursor: 'pointer' }}>
                                                {confirmPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                                            </span>
                                        </div>

                                        <div className="col-12 mt-4">
                                            <label>Service Location</label>
                                            <LeafletMap setLocation={setLocation} setAddress={setAddress} location={location} address={address} isMobile={isMobile} />
                                        </div>

                                        <div className="col-12 mt-3">
                                            <span className="dc-checkbox">
                                                <input type="checkbox" name="termsconditions" id="terms" checked={formData.termsconditions} onChange={handleChange} />
                                                <label htmlFor="terms">I accept the terms and conditions</label>
                                            </span>
                                        </div>

                                        <div className="col-12 text-end mt-4">
                                            <button type="submit" className="dc-btn" disabled={loading}>
                                                {loading ? "Adding..." : "Add Ambulance"}
                                            </button>
                                        </div>
                                    </fieldset>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

export default AddAmbulance;
